<script setup>
import toStrapiLocale from "~/helpers/toStrapiLocale";
const { t } = useI18n({ useScope: "local" });
const props = defineProps({
  offices: {
    type: Array,
    default: [],
  },
  coinsInOffices: {
    type: Array,
    default: [],
  },
});

const data = computed(() => {
  if (!props.coinsInOffices.length) {
    return props.offices.map((item) => {
      return {
        count: 0,
        ...item,
      };
    });
  }
  return props.coinsInOffices.map((item) => {
    return {
      count: item.count,
      id: item.office.id,
      adress: item.office.adress,
      time: item.office.time,
    };
  });
});

const coordinates = computed(() => {
  const arr = [];
  if (!!props.coinsInOffices && props.coinsInOffices.length) {
    props.coinsInOffices.forEach((el) => {
      arr.push([el.office.coordinates.x, el.office.coordinates.y]);
    });
    return arr;
  } else if (!!props.offices && props.offices.length) {
    props.offices.forEach((location) => {
      arr.push([location.coordinates.x, location.coordinates.y]);
    });
    return arr;
  }
  return [];
});
</script>

<template>
  <div class="flex flex-col-reverse md:grid md:grid-cols-12 gap-4 md:gap-6">
    <div class="col-start-1 col-end-7 h-full w-full font-firasans">
      <div
        class="overflow-y-auto h-fit max-h-[380px] lg:max-h-[475px] lg:h-[475px] w-full custom-scroll"
      >
        <div
          class="flex flex-row space-x-2 text justify-between text-[#6F6F6F] font-sans pb-1 lg:pb-0 lg:mb-[10px]"
        >
          <p>Офис</p>
          <p>Монет в наличии</p>
        </div>
        <div
          v-for="location in data"
          :key="location.id"
          :class="{ 'bg-carrot': selectedAdress === location.id }"
          class="flex flex-row justify-between items-center py-[10px] border-b-[1px] lg:border-b-[0px] lg:border-t-[1px] w-full border-[#F3F3F7] cursor-pointer"
        >
          <div>
            <p
              class="text-base lg:pl-1 lg:text-lg font-firasans font-medium mb-1 lg:mb-3"
              v-html="location.adress"
            ></p>
            <div
              class="lg:pl-1 text-[#6F6F6F] text-sm !leading-5 font-sans leading-5 lg:text-base"
            >
              <span v-html="location.time"></span>
            </div>
          </div>
          <div class="font-sans text-sm md:text-lg font-medium" v-if="location.count>0">{{location.count}} шт.</div>
        </div>
      </div>
    </div>
    <div class="relative col-start-7 col-end-13 h-full">
      <AMap
        class="!h-full min-h-73 md:!min-h-[350px]"
        :coordinates="coordinates"
      ></AMap>
      <nuxt-link
        :to="localePath('/offices')"
        class="block !absolute !w-full px-4 bottom-4"
      >
        <AButton
          type="map"
          class="!rounded-[10px] lg:!rounded-full text-lg lg:ml-auto !font-medium !w-full lg:!w-68 lg:!w-36"
        >
          {{ t("Перейти") }}</AButton
        >
      </nuxt-link>
    </div>
  </div>
</template>

<i18n lang="json">
{
  "ru": {
    "Офисы и банкоматы": "Офисы и банкоматы",
    "Адреса отделений и банкоматов Амра-Банка на карте": "Адреса отделений и банкоматов Амра-Банка на карте",
    "график работы, телефоны": "график работы, телефоны",
    "Перейти": "Перейти"
  },
  "en": {
    "Офисы и банкоматы": "Offices and ATMs",
    "Адреса отделений и банкоматов Амра-Банка на карте": "Addresses of Amra Bank branches and ATMs on the map",
    "график работы, телефоны": "working hours, phone numbers",
    "Перейти": "Go"
  },
  "es": {
    "Офисы и банкоматы": "Oficinas y cajeros automáticos",
    "Адреса отделений и банкоматов Амра-Банка на карте": "Direcciones de las sucursales y cajeros automáticos de Amra Bank en el mapa",
    "график работы, телефоны": "horario de trabajo, números de teléfono",
    "Перейти": "Ir"
  },
  "ar": {
    "Офисы и банкоматы": "المكاتب وأجهزة الصراف الآلي",
    "Адреса отделений и банкоматов Амра-Банка на карте": "عناوين فروع وأجهزة الصراف الآلي لبنك عمرا على الخريطة",
    "график работы, телефоны": "ساعات العمل، أرقام الهاتف",
    "Перейти": "اذهب"
  },
  "tr": {
    "Офисы и банкоматы": "Ofisler ve ATM'ler",
    "Адреса отделений и банкоматов Амра-Банка на карте": "Amra Bank şubeleri ve ATM'lerinin adresleri haritada",
    "график работы, телефоны": "çalışma saatleri, telefon numaraları",
    "Перейти": "Git"
  }
}
</i18n>
